export default __webpack_public_path__ + "static/media/water.cdcfe1a0.png";